import React from "react";
import { Box, Typography, Stack, Divider, alpha, useTheme } from "@mui/material";
import { Person, AccessTime } from "@mui/icons-material";
import CustomInput from "../../../components/CustomForm/CustomInput";

const ExecutionDetails = ({
  executionDetails,
  executionFormData,
  handleChange,
}) => {
  const theme = useTheme();

  if (!executionDetails?.length) return null;

  return (
    <Box sx={{ mt: 2 }}>
      <Typography
        variant="subtitle2"
        fontWeight={700}
        sx={{
          mb: 2,
          color: theme.palette.text.secondary,
          textTransform: "uppercase",
          letterSpacing: "0.5px",
          fontSize: "0.7rem",
        }}
      >
        Execution Details
      </Typography>

      <Stack spacing={2}>
        {executionDetails?.map((employee) => (
          <Box
            key={employee.id}
            sx={{
              p: 2,
              borderRadius: 2,
              bgcolor: alpha(theme.palette.background.default, 0.4),
              border: `1px solid ${alpha(theme.palette.divider, 0.06)}`,
            }}
          >
            <Stack
              direction={{ xs: "column", sm: "row" }}
              alignItems={{ xs: "flex-start", sm: "center" }}
              spacing={{ xs: 1.5, sm: 2 }}
            >
              <Box sx={{ minWidth: { sm: 140 } }}>
                <Stack direction="row" alignItems="center" spacing={1}>
                  <Person
                    sx={{
                      fontSize: 18,
                      color: theme.palette.primary.main,
                    }}
                  />
                  <Typography variant="body2" fontWeight={600}>
                    {employee.first_name} {employee.last_name}
                  </Typography>
                </Stack>
              </Box>

              <Box sx={{ flex: 1, width: "100%" }}>
                <Stack
                  direction={{ xs: "column", sm: "row" }}
                  spacing={{ xs: 1, sm: 2 }}
                >
                  <Box sx={{ flex: 1, minWidth: { sm: 200 } }}>
                    <CustomInput
                      type="datetime-local"
                      label="Actual Start"
                      value={executionFormData[employee.id]?.actual_start || ""}
                      onChange={(e) =>
                        handleChange(employee.id, "actual_start", e.target.value)
                      }
                      required
                      sx={{
                        "& .MuiInputBase-input": {
                          fontSize: "0.8rem",
                          padding: "6px 12px",
                        },
                        "& .MuiInputLabel-root": {
                          fontSize: "0.7rem",
                        },
                      }}
                      InputLabelProps={{ shrink: true }}
                    />
                  </Box>

                  <Box sx={{ flex: 1, minWidth: { sm: 200 } }}>
                    <CustomInput
                      type="datetime-local"
                      label="Actual End"
                      value={executionFormData[employee.id]?.actual_end || ""}
                      onChange={(e) =>
                        handleChange(employee.id, "actual_end", e.target.value)
                      }
                      required
                      sx={{
                        "& .MuiInputBase-input": {
                          fontSize: "0.8rem",
                          padding: "6px 12px",
                        },
                        "& .MuiInputLabel-root": {
                          fontSize: "0.7rem",
                        },
                      }}
                      InputLabelProps={{ shrink: true }}
                    />
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      px: 1.5,
                      py: 0.5,
                      borderRadius: 1,
                      bgcolor: alpha(theme.palette.info.main, 0.06),
                      border: `1px solid ${alpha(theme.palette.info.main, 0.1)}`,
                      minWidth: { sm: 80 },
                      justifyContent: "center",
                    }}
                  >
                    <AccessTime
                      sx={{
                        fontSize: 14,
                        color: theme.palette.info.main,
                        mr: 0.5,
                      }}
                    />
                    <Typography variant="caption" fontWeight={600} color="info.main">
                      Required
                    </Typography>
                  </Box>
                </Stack>
              </Box>
            </Stack>
          </Box>
        ))}
      </Stack>
    </Box>
  );
};

export default ExecutionDetails;